// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SelfServiceSettingsController = function ($scope, $http, SelfServiceSettings, gettextCatalog, gettext, $rootScope, CommonObjects) {

    $scope.settingsCopy = null;
    $scope.TermsOfContract = null;

    $scope.attachment = setupBlankAttachment();
    $scope.isError = false;
    $scope.errorMessage = '';
    $scope.chosenFileText = gettextCatalog.getString(gettext("No file chosen"));

    $scope.settings = SelfServiceSettings.get({}, function() {
        let termsOfContract = $scope.settings.Signup.TermsOfContract;
        let htmlDecode = function (str) {
            return String(str)
                .replace(/(&amp;)/g, '&')
                .replace(/(&quot;)/g, '"')
                .replace(/(&#39;)/g, "'")
                .replace(/(&lt;)/g, '<')
                .replace(/(&gt;)/g, '>');
        };

        for (let i = 0; i < termsOfContract.length; i++) {
            termsOfContract[i].Text["_c"] = htmlDecode(termsOfContract[i].Text["_c"]);
        }

        $scope.TermsOfContract = termsOfContract;
        createSettingsCopy();
    });
    
    $scope.ContractualTermAcceptOptions = [{Key:"Required", Value: true }, {Key:"Not Required", Value: false }];
    
    $scope.save = function () {
        if($scope.settingsCopy && $scope.settings.SendDocumentsByEmail !== $scope.settingsCopy.SendDocumentsByEmail) {
            $scope.yesNoCancel(gettextCatalog.getString(gettext('Update default dispatch')), gettextCatalog.getString(gettext('Do you want to update the default dispatch for all existing customers as well?')),
                function () {
                    $scope.settings.UpdatePropertiesForAll = true;
                    saveSettings();
                },
                function () {
                    $scope.settings.UpdatePropertiesForAll = false;
                    saveSettings();
                }
            );
        } else {
            saveSettings();
        }
    };
    
    $scope.uploadCompleted = function (content) {

        resetFilesSelection();

        if (!content)
            return;

        if (content.status == "success") {
            $scope.notify("success", gettextCatalog.getString(gettext("Logo uploaded")));
            SelfServiceSettings.get(function (data) {
                if (data && data.Style && data.Style.Logo)
                    $scope.settings.Style.Logo = data.Style.Logo;
            });

        } else {
            $scope.notify("error", "Upload error: " + content.message);
        }
    };

    $scope.resetLogo = function () {
        $scope.settings.Style.Logo = null;
    };

    $scope.resetStyles = function () {
        $scope.yesCancel(gettextCatalog.getString(gettext('Resetting styles')), gettextCatalog.getString(gettext('Are you sure?')), function () {
            $http({
                method: "POST",
                url: "api/v1/selfServiceSettings/resetStyles",
                cache: false
            }).then(function (response) {
                $scope.settings = response.data;
                createSettingsCopy();
            });
        });
    };

    $scope.setFocus = function (event,id) {
        $('#' + id).focus();
        event.stopPropagation();
    };

    $scope.getActionPath = function () {
        return 'imageupload/upload?selected_legal_entity_id=' + encodeURIComponent($rootScope.chosenEntity.Id);
    };
    
    $scope.IsTermsOfContractEmpty = function () {
        if ($scope.TermsOfContract) {
            return $scope.TermsOfContract.length === 0;
        }
    };
    
    $scope.addContractualTerm = function () {
        if($scope.TermsOfContract.length < $scope.settings.Signup.MaxTermsOfContract)
        {
            let Text = { _c: ""};
            let IsConfirmNeeded = true;
            $scope.TermsOfContract.push({ Text, IsConfirmNeeded });
        }
    };
    
    $scope.removeContractualTerm = function (index) {
        $scope.TermsOfContract.splice(index, 1);
    };
    $scope.$watch('errorResponse', function (newValue) {
        if (newValue) {
            $scope.notify('error', 'Upload error: ' + newValue.Message);
        }
    });
    
    $scope.$watch('errorMessage', function (newValue) {
        if (newValue) {
            $scope.notify('error', 'Upload error: ' + newValue);
            $scope.errorMessage = '';
        }
    });

    $scope.$watch('attachment', function (newValue, oldValue) {
        if (newValue && newValue.Files && newValue.Files['_c'] && newValue.Files['_c'].FileName && newValue.Files['_c'].FileName.length > 0) {
            $scope.getChosenFileText(newValue.Files['_c'].FileName);
        }
        else {
            $scope.getChosenFileText(null);
        }
    }, true);

    $scope.onSuccessCallback = function () {
        $scope.uploadCompleted($scope.successResponse);
    };

    $scope.saveUpload = function () {
        $scope.successResponse = '';
        if ($scope.isSavingForbidden()) {
            $scope.errorMessage = 'Nothing to save yet. Please choose a file first.';
        } else {
            $scope.saveImage();
        }
    };

    $scope.isSavingForbidden = function () {
        var fileName = $scope.attachment.Files['_c'].FileName;        
        return (!fileName || fileName.length === 0);
    };

    $scope.getFileUploaderText = function () {
        return gettextCatalog.getString(gettext('Choose file'));
    };

    $scope.getChosenFileText = function (fileName) {
        $scope.chosenFileText = fileName ? fileName : gettextCatalog.getString(gettext("No file chosen"));
    };

    $scope.dataInvalid = function () {
        return $scope.isSavingForbidden();
    };

    function saveSettings() {
        SelfServiceSettings.save($scope.settings, function (data) {
            $scope.notifySuccess();
            $scope.settingsCopy = data;
        });
    };

    function createSettingsCopy() {
        $scope.settingsCopy = angular.copy($scope.settings);
    };

    function resetFilesSelection() {
        $scope.attachment = setupBlankAttachment();
    };

    function setupBlankAttachment() {
        return CommonObjects.BlankAttachment.get();
    };
};
SelfServiceSettingsController.$inject = ['$scope', '$http', 'SelfServiceSettings', 'gettextCatalog', 'gettext', '$rootScope', 'CommonObjects'];
